<template>
    <m-filter :text="text" :popup.sync="popup" :filtered="filtered">
        <div class="hover_text-primary-600 text-sm text-gray-600 inline-block cursor-pointer underline"
             @click="today">Today
        </div>
        <div class="inline-block px-2">|</div>
        <div class="hover_text-primary-600 text-sm text-gray-600 inline-block cursor-pointer underline"
             @click="previous">Previous Billing Cycle
        </div>
        <div class="inline-block px-2">|</div>
        <div class="hover_text-primary-600 text-sm text-gray-600 inline-block cursor-pointer underline"
             @click="current">Current Billing Cycle
        </div>
        <div class="text-sm">From:</div>
        
        <m-datepicker-native class="w-full" v-model="from"></m-datepicker-native>
        <div class="text-sm">To:</div>
        <m-datepicker-native class="w-full" v-model="to"></m-datepicker-native>
        <div class="block mt-2">
            <div class="btn-sm btn-primary" @click="apply()">Apply</div>
        </div>
    </m-filter>
</template>

<script>
import {dateFormat} from '@/js/date'
import billingCycle from '@/js/billingcycle.js'

export default {
    props: {
        value: Object,
        text: String
    },
    data() {
        return {
            from: this.value?.from,
            to: this.value?.to,
            popup: false
        }
    },
    created() {
        // this.current()
        // this.apply()
    },
    computed: {
        filtered() {
            if (this.value == null) {
                return ''
            }
            return `${dateFormat(this.value.from, '%d %M %Y')} - ${dateFormat(this.value.to, '%d %M %Y')}`
        }
    },
    methods: {
        apply() {
            this.$emit('input', this.from == null && this.to == null ? null : {from: this.from, to: this.to});
            this.popup = false;
        },
        today() {
            this.from = new Date()
            this.to = new Date()
        },
        current() {
            var {from, to} = billingCycle(0)
            this.from = from
            this.to = to
        },
        previous() {
            var {from, to} = billingCycle(-1)
            this.from = from
            this.to = to
        }
    }
};
</script>

